import React, { useState } from "react";
import { ReasoningPart } from "common/utils/chatAgent/types";
import { Markdown } from "../../Common/__styles__/Markdown";
import { Icon } from "../../Common/Icons/LucideIcons";
import {
  ChevronIcon,
  FinishedThinkingText,
  HeaderContent,
  ReasoningContainer,
  ReasoningContent,
  ReasoningHeader,
  ThinkingText,
} from "./__styles__/ReasoningCard";

export type ReasoningCardProps = {
  reasoningPart: ReasoningPart;
  isLoading?: boolean;
};

const ReasoningCard = ({
  reasoningPart,
  isLoading = false,
}: ReasoningCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!reasoningPart.content) {
    return null;
  }

  const formattedReasoning = reasoningPart.content.replace(/\\n/g, "  \n");

  return (
    <ReasoningContainer>
      <ReasoningHeader
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls="reasoning-content"
      >
        <HeaderContent>
          {isLoading ?
            <ThinkingText data-content="Thinking...">Thinking...</ThinkingText>
          : <FinishedThinkingText>Finished thinking</FinishedThinkingText>}
          <ChevronIcon>
            <Icon
              iconName={isOpen ? "chevron-up" : "chevron-down"}
              size={16}
              color="contentSecondary"
            />
          </ChevronIcon>
        </HeaderContent>
      </ReasoningHeader>
      {isOpen && (
        <ReasoningContent id="reasoning-content">
          <Markdown
            markdown={formattedReasoning}
            css={{
              fontSize: "14px",
              fontFamily: "Inter",
              lineHeight: "20px",
              color: "#0C1629",
              padding: "12px",
              p: {
                margin: 0,
                fontSize: "14px",
                fontFamily: "Inter",
                lineHeight: "20px",
                color: "#0C1629",
              },
            }}
          />
        </ReasoningContent>
      )}
    </ReasoningContainer>
  );
};

export default ReasoningCard;
